import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import initBootstrapComponents from '../../utils/bootstrap';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import { API_BASE_URL } from '../../constants/api';
import axios from "axios";
import EventCard from "./components/EventCard";
import { Riple } from "react-loading-indicators";

// Import images
import motabilityLogo from '../../assets/img/logos/motability-scheme.svg';
import motabilityBlueLogo from '../../assets/img/logos/motability-scheme-blue.svg';
import evChargingStation from '../../assets/img/backgrounds/ev-charging-station.jpg';
import circularPattern from '../../assets/img/logos/circular-m-pattern-small.svg';
import whiteUpArrow from '../../assets/img/icons/white-up-arrow.svg';

const Home = () => {
    // Replace PHP $siteUrl with a constant or environment variable
    const siteUrl = process.env.REACT_APP_SITE_URL || '/';

    const [events, setEvents] = useState([]);
    const navigate = useNavigate();
    useEffect(() => {
        // Initialize Bootstrap components when component mounts
        initBootstrapComponents();
    }, []);

    useEffect(() => {
        axios.get(`${API_BASE_URL}/api/events?key=7678356c642c91a255471d162205e0f3`)
            .then(response => {
                console.log('response', response);
                setEvents(response.data.data);
            })
            .catch(error => {
                console.error('Error fetching events:', error);
            });
    }, []);

    const handleEventSelect = (event) => {
        navigate(event.supports_vehicle_booking ? `/event/${event.id}/vehicle-list` : `/event/${event.id}/availability`);
    };

    return (
        <div className="d-flex flex-column justify-content-between min-vh-100" id="body-container">
            <Header />

            <main>
                <section className="hero-banner curved-bottom bg-motability-light-blue">
                    <div className="container-fluid">
                        <div className="row">
                            <article className="content-col col-lg-6 py-32 py-lg-124">
                                <img
                                    src={motabilityBlueLogo}
                                    alt="Motability Scheme"
                                    width="340"
                                    height="90"
                                    className="img-fluid mb-4 mb-lg-32"
                                    fetchPriority="high"
                                    loading="eager"
                                    decoding="sync"
                                />

                                <h1 className="text-primary lh-110 mb-4 mb-lg-32">
                                    Test drive experiences
                                </h1>
                                
                                <p>
                                    Test Drive Days are FREE to attend with FREE parking. Test Drives must be booked in advance. 
                                    Please only attend if you have a Test Drive booked. To avoid disappointment, we recommend 
                                    booking as early as possible to secure your preferred slots.
                                </p>

                                <p>
                                    Remember to check you meet our Test Drive T&Cs and to bring your full UK driving licence 
                                    with you on the day.
                                </p>

                                <Link to="/event-select" className="btn btn-primary text-motability-white d-inline-flex align-items-center mt-4 mt-lg-32">
                                    View events
                                </Link>
                            </article>

                            <aside className="col-lg-6 position-relative px-0 px-lg-12">
                                <img
                                    src={evChargingStation}
                                    alt="Electric vehicle at a charging station"
                                    width="1380"
                                    height="893"
                                    className="img-fluid position-lg-absolute top-0 start-0 w-100 h-100 object-fit-cover"
                                    fetchPriority="high"
                                    loading="eager"
                                    decoding="sync"
                                />
                            </aside>
                        </div>
                    </div>
                </section>

                <section className="three-column-cards-carousel bg-motability-mid-black-7 position-relative transform-bg-colour py-32 pt-lg-72 pb-lg-96">
                    <div className="container">
                        <div className="intro-content">
                            <h2 className="text-primary mb-4 mb-lg-32">
                                Upcoming events
                            </h2>
                        </div>


                        {events.length == 0 ? 
                                    <div className="mt-32 d-flex justify-content-center align-items-center h-100 min-vh-50">
                                        <Riple color="#0052BE" size="medium" text="" textColor="" />
                                    </div>
                                :
                        <Splide
                            className="cards-carousel mt-4 mt-lg-5"
                            options={{
                                perPage: 3,
                                gap: '1.5rem',
                                breakpoints: {
                                    991: {
                                        perPage: 2,
                                    },
                                    767: {
                                        perPage: 1,
                                    },
                                },
                                pagination: false,
                                arrows: true,
                            }}
                        >

                            {events
                                .filter((event) => event.is_live === 1)
                                .sort((a, b) => new Date(a.start_at) - new Date(b.start_at))
                                .map((event) => (
                                    <EventCard key={event.id} event={event} buttonText="View event" onSelect={handleEventSelect} />
                            ))}
                        </Splide>
                        }

                    </div>
                </section>

                <section className="two-column-content-media content-video py-32 py-lg-124">
                    <div className="container">
                        <div className="d-flex flex-column flex-xl-row rounded-4 overflow-hidden">
                            <div className="col-12 col-xl-6 bg-primary text-white">
                                <div className="primary h-100">
                                    <div className="p-32 py-xl-76 px-xl-72">
                                        <h2>
                                            Take a look at the test drive
                                        </h2>

                                        <p>
                                            Here's a little taster of what you can expect to find at our events. From a huge range 
                                            of vehicles to <strong>view and test drive</strong> plus <strong>expert advice</strong> from 
                                            our team, it's all at Motability Scheme Live!
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 col-xl-6 gx-0">
                                <div className="ratio ratio-16x9 h-100">
                                    <iframe 
                                        src="https://www.youtube.com/embed/z6vsegllJls?si=rvtRBX18IVmSmjrX" 
                                        title="The Big Event 2024 Drone Footage" 
                                        allowFullScreen 
                                        loading="lazy"
                                    ></iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>

            <Footer />
        </div>
    );
};

export default Home;
